import { useState } from 'react';

import ModalShell from '../components/ModalShell.jsx';
import { WEEK_DAYS } from './scheduleEditModel.js';

// Copy one day's events onto other days of the SAME zone. The chosen days'
// existing events are replaced (darwin_core's copySchedule), and the result is
// applied to the draft — so it previews in the grid and saves with everything
// else. The source day is excluded from the target list.
export default function CopyDayModal({ fromDay, onCopy, onClose }) {
  const [selected, setSelected] = useState([]);

  const toggle = (day) =>
    setSelected((s) =>
      s.includes(day) ? s.filter((d) => d !== day) : [...s, day],
    );

  const targets = WEEK_DAYS.filter((d) => d !== fromDay);

  return (
    <ModalShell labelledBy="copy-day-title" onClose={onClose}>
      <h2 id="copy-day-title" className="schedule-modal__title">
        Copy {fromDay} to…
      </h2>
      <ul className="copy-list" role="group" aria-label={`Copy ${fromDay} to`}>
        {targets.map((day) => (
          <li key={day}>
            <label className="copy-check">
              <input
                type="checkbox"
                checked={selected.includes(day)}
                onChange={() => toggle(day)}
              />
              <span>{day}</span>
            </label>
          </li>
        ))}
      </ul>
      <div className="schedule-modal__actions">
        <button
          type="button"
          className="schedule-modal__save"
          disabled={selected.length === 0}
          onClick={() => onCopy(selected)}
        >
          Copy
        </button>
        <button
          type="button"
          className="schedule-modal__cancel"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </ModalShell>
  );
}
